export const apiUrl = process.env.REACT_APP_API;

export const appName = 'hub';
export const appEnv = process.env.REACT_APP_ENV;
export const isDev = appEnv === 'development';
export const isStage = appEnv === 'stage';
export const isProd = appEnv === 'production';
export const isDemo = appEnv === 'demo';
export const captchaSitekey = '6Let9uIqAAAAAMb7BaIspkmf-3LobZ4HgtowgMnI';
export const SSO_client_id = (isDev || isStage || isDemo) ? 'fc20c6e4-3266-42b2-8275-7b84407cea02' : 'a06b993f-3aaf-44f0-acd3-2e1151d029d6'; //stage may split later
export const SSO_scope_server_id = (isDev || isStage || isDemo) ? 'api://eecc7a2d-20bc-4ccc-8dff-7ef453da4093/AgUnity_Access' : 'api://3efa4de9-eab0-45e2-b13e-3a02287cfbe6/AgUnity_Access'; //stage may split later
export const tokenKey = 'bQeThWmZq4t7w!z%C*F-JaNcRfUjXn2r';